import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const headerContainerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.012, delayChildren: 0.15 } }
};

const letterVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: { opacity: 1, y: 0, transition: { type: 'spring', damping: 24, stiffness: 150 } }
};

const formContainerVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.3 } }
};

const headlineText = "Let's create a digital strategy that connects with your audience, strengthens your brand, and delivers measurable growth.";
const words = headlineText.split(" ");

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Load Formnx scripts for resizing and widget functionality
    const script1 = document.createElement('script');
    script1.src = "https://formnx.com/js/iframeResizer.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = "https://formnx.com/js/widget.js";
    script2.async = true;
    document.body.appendChild(script2);

    return () => {
      if (document.body.contains(script1)) document.body.removeChild(script1);
      if (document.body.contains(script2)) document.body.removeChild(script2);
    };
  }, []);

  return (
    <section id="contacts" className="w-full bg-[#FFFFFF] min-h-screen pt-32 pb-24 select-none overflow-hidden flex flex-col items-center relative">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8 lg:px-16 flex flex-col lg:flex-row gap-0 lg:gap-[36px]">
        <div className="flex flex-col items-start xl:w-[1312px] w-full pb-[96px] lg:pb-[120px]">
          <motion.h2 
            variants={headerContainerVariants} 
            initial="hidden" 
            whileInView="visible" 
            viewport={{ once: true, margin: "-120px" }}
            className="w-full text-[28px] sm:text-[38px] lg:text-[48px] font-medium leading-[1.3] sm:leading-[1.25] lg:leading-[1.12] tracking-[-1.44px] text-[#000000] text-left mb-[64px]"
          >
            <div className="float-left flex items-center gap-[12px] h-[28px] sm:h-[36px] lg:h-[40px] mr-[48px] sm:mr-[72px] select-none">
              <div className="w-[12px] h-[12px] rounded-full bg-blue-600 flex-shrink-0 animate-pulse" />
              <span className="text-[18px] sm:text-[24px] font-medium tracking-[-0.24px] leading-none text-[#000000]">
                Contact
              </span>
            </div>
            {words.map((word, i) => (
              <span key={i} className="inline-block whitespace-nowrap mr-[0.25em]">
                {word.split("").map((char, j) => (
                  <motion.span key={j} variants={letterVariants} className="inline-block">
                    {char}
                  </motion.span>
                ))}
              </span>
            ))}
          </motion.h2>

          <motion.div 
            variants={formContainerVariants} 
            initial="hidden" 
            whileInView="visible" 
            viewport={{ once: true, margin: "-100px" }}
            className="w-full xl:w-[1312px] bg-[#F8FAFC] rounded-[24px] p-2 sm:p-4 border border-blue-50 shadow-[0_20px_50px_rgba(37,99,235,0.04)] text-left overflow-hidden min-h-[600px]"
          >
            <iframe 
              id="formnx-12sh72-lvghnk2m" 
              src="https://fill.formnx.com/f/hostfig-enquiry-12sh72?iframe=true" 
              title="HostFig Enquiry" 
              style={{ width: '1px', minWidth: '100%', border: 0, height: '750px' }}
            ></iframe>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;